import { AxiosError } from "axios"

export type InitialState = {
    nomenclatureList: {
        data: NomenclatureItem[];
        loading: boolean;
        error: AxiosError | null;
    },
    nomenclatureListCreate: {
        loading: boolean;
        error: AxiosError | null;
        data: boolean
    },
    nomenclatureListEdit: {
        loading: boolean;
        error: AxiosError | null;
    },
    nomenclatureListDetail: {
        data: NomenclatureItem | null;
        loading: boolean;
        error: AxiosError | null;
    },
    nomenclatureListDelete: {
        data: boolean;
        loading: boolean;
        error: AxiosError | null;
    },
}


//СПИСОК
export const START_NOMENCLATURE_LIST = 'START_NOMENCLATURE_LIST';
interface StartNomenclatureList {
    type: typeof START_NOMENCLATURE_LIST;
    payload: NomenclatureItem[];
}
export const STOP_NOMENCLATURE_LIST = 'STOP_NOMENCLATURE_LIST';
interface StoptNomenclatureList {
    type: typeof STOP_NOMENCLATURE_LIST;
}
export const FILL_NOMENCLATURE_LIST = 'FILL_NOMENCLATURE_LIST';
interface FillNomenclatureList {
    type: typeof FILL_NOMENCLATURE_LIST;
    payload: NomenclatureItem[];
}
export const ERROR_NOMENCLATURE_LIST = 'ERROR_NOMENCLATURE_LIST';
interface ErrorNomenclatureList {
    type: typeof ERROR_NOMENCLATURE_LIST;
    payload: AxiosError;
}
export const ASYNC_NOMENCLATURE_LIST = 'ASYNC_NOMENCLATURE_LIST';










//ИЗМЕНЕНИЕ
export const START_NOMENCLATURE_CHANGE = 'START_NOMENCLATURE_CHANGE';
interface StartNomenclatureChange {
    type: typeof START_NOMENCLATURE_CHANGE;
}
export const STOP_NOMENCLATURE_CHANGE = 'STOP_NOMENCLATURE_CHANGE';
interface StoptNomenclatureChange {
    type: typeof STOP_NOMENCLATURE_CHANGE;
}
export const FILL_NOMENCLATURE_CHANGE = 'FILL_NOMENCLATURE_CHANGE';
interface FillNomenclatureChange {
    type: typeof FILL_NOMENCLATURE_CHANGE;
}
export const ERROR_NOMENCLATURE_CHANGE = 'ERROR_NOMENCLATURE_CHANGE';
interface ErrorNomenclatureChange {
    type: typeof ERROR_NOMENCLATURE_CHANGE;
    payload: AxiosError;
}
export const ASYNC_NOMENCLATURE_CHANGE = 'ASYNC_NOMENCLATURE_CHANGE';










//ДЕТАЛИ
export const START_NOMENCLATURE_DETAIL = 'START_NOMENCLATURE_DETAIL';
interface StartNomenclatureDetail {
    type: typeof START_NOMENCLATURE_DETAIL;
}
export const STOP_NOMENCLATURE_DETAIL = 'STOP_NOMENCLATURE_DETAIL';
interface StoptNomenclatureDetail {
    type: typeof STOP_NOMENCLATURE_DETAIL;
}
export const FILL_NOMENCLATURE_DETAIL = 'FILL_NOMENCLATURE_DETAIL';
interface FillNomenclatureDetail {
    type: typeof FILL_NOMENCLATURE_DETAIL;
}
export const ERROR_NOMENCLATURE_DETAIL = 'ERROR_NOMENCLATURE_DETAIL';
interface ErrorNomenclatureDetail {
    type: typeof ERROR_NOMENCLATURE_DETAIL;
    payload: AxiosError;
}
export const ASYNC_NOMENCLATURE_DETAIL = 'ASYNC_NOMENCLATURE_DETAIL';





//УДАЛЕНИЕ
export const START_NOMENCLATURE_DELETE = 'START_NOMENCLATURE_DELETE';
interface StartNomenclatureDelete {
    type: typeof START_NOMENCLATURE_DELETE;
}
export const STOP_NOMENCLATURE_DELETE = 'STOP_NOMENCLATURE_DELETE';
interface StoptNomenclatureDelete {
    type: typeof STOP_NOMENCLATURE_DELETE;
}
export const FILL_NOMENCLATURE_DELETE = 'FILL_NOMENCLATURE_DELETE';
interface FillNomenclatureDelete {
    type: typeof FILL_NOMENCLATURE_DELETE;
}
export const ERROR_NOMENCLATURE_DELETE = 'ERROR_NOMENCLATURE_DELETE';
interface ErrorNomenclatureDelete {
    type: typeof ERROR_NOMENCLATURE_DELETE;
    payload: AxiosError;
}
export const ASYNC_NOMENCLATURE_DELETE = 'ASYNC_NOMENCLATURE_DELETE';






//СОЗДАНИЕ
export const START_NOMENCLATURE_CREATE = 'START_NOMENCLATURE_CREATE';
interface StartNomenclatureCreate {
    type: typeof START_NOMENCLATURE_CREATE;
}
export const STOP_NOMENCLATURE_CREATE = 'STOP_NOMENCLATURE_CREATE';
interface StoptNomenclatureCreate {
    type: typeof STOP_NOMENCLATURE_CREATE;
}
export const FILL_NOMENCLATURE_CREATE = 'FILL_NOMENCLATURE_CREATE';
interface FillNomenclatureCreate {
    type: typeof FILL_NOMENCLATURE_CREATE;
}
export const ERROR_NOMENCLATURE_CREATE = 'ERROR_NOMENCLATURE_CREATE';
interface ErrorNomenclatureCreate {
    type: typeof ERROR_NOMENCLATURE_CREATE;
    payload: AxiosError;
}
export const ASYNC_NOMENCLATURE_CREATE = 'ASYNC_NOMENCLATURE_CREATE';





export type ActionNomenclatureType =
StartNomenclatureList |
StoptNomenclatureList |
FillNomenclatureList |
ErrorNomenclatureList |
StartNomenclatureChange |
StoptNomenclatureChange |
FillNomenclatureChange |
ErrorNomenclatureChange |
StartNomenclatureDetail |
StoptNomenclatureDetail |
FillNomenclatureDetail |
ErrorNomenclatureDetail |
StartNomenclatureDelete |
StoptNomenclatureDelete |
FillNomenclatureDelete |
ErrorNomenclatureDelete |
StartNomenclatureCreate |
StoptNomenclatureCreate |
FillNomenclatureCreate |
ErrorNomenclatureCreate 




export type NomenclatureItem = {
    id: number
    name: string
    printName: string
    comment: string
    isDeleted: boolean
}

export type NomenclatureItemCreate = {
    id?: number
    name: string
    printName: string
    comment: string
    isDeleted: boolean
    compositions: CompositionsItem[]
}

export type CompositionsItem = {
    materialId: number;
    quantity: number;
}